import type { TApiResponse, TApiResponseType } from '@/types/api-types/TApiResponse'
import HaulageJobsApiUrls from './endpoints'
import BaseApiRequest from '../BaseApiRequest'
import type {
  TGetHaulageJobsParams,
  IHaulageJobsApi,
  TGetHaulageJobByIdParams,
  TUpdateHaulageJobParams,
  TUpdateHaulageJobByIdRequestBody,
  TDeleteHaulageJobParams,
  TCreateHaulageJobRequestBody
} from '@/types/api-types/haulageJob'
import type { IBulkOperationResponseType } from '@/types/api-types/IApiResponse'
import type { TItemRequestQueryParams } from '@/types/api-types'

class HaulageJobsApiRequest extends BaseApiRequest implements IHaulageJobsApi {
  async getHaulageJob(params: TGetHaulageJobsParams): TApiResponse {
    return this.get(HaulageJobsApiUrls.HAULAGE_JOBS(), params)
  }

  async getHaulageJobById(params: TGetHaulageJobByIdParams): TApiResponse {
    const { id, ...rest } = params
    const url = `${HaulageJobsApiUrls.HAULAGE_JOBS_BY_ID(id)}`
    return this.get(url, rest)
  }

  async editHaulageJob(
    params: TUpdateHaulageJobParams,
    requestBody: TUpdateHaulageJobByIdRequestBody
  ): TApiResponse {
    const { id, ...rest } = params
    const url = `${HaulageJobsApiUrls.HAULAGE_JOBS_BY_ID(id)}`
    return this.put(url, requestBody, rest)
  }

  async deleteHaulageJob(
    params?: TDeleteHaulageJobParams
  ): TApiResponseType<IBulkOperationResponseType> {
    return this.delete(HaulageJobsApiUrls.HAULAGE_JOBS(), params)
  }

  async addHaulageJob(requestBody: TCreateHaulageJobRequestBody, params?: TItemRequestQueryParams ): TApiResponse {
    return this.post(HaulageJobsApiUrls.HAULAGE_JOBS(), requestBody, params)
  }
}

export default HaulageJobsApiRequest
